/**
 * StreamStatusDTO entity class
 */

/**
 * StreamStatusDTOFactory
 * returns StreamStatusDTO entity class
 *
 * @class StreamStatusDTOFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.StreamStatusDTO} class
 *
 * @ngdoc factory
 * @name mwApp.factory:StreamStatusDTOFactory
 */
/* @ngInject */
export default function StreamStatusDTOFactory (Entity) {
  /* === StreamStatusDTO class === */

  /**
   * StreamStatusDTO model
   *
   * @class StreamStatusDTO
   * @classdesc StreamStatusDTO model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing StreamStatusDTO entity fields
   * @return {models.StreamStatusDTO} StreamStatusDTO entity
   */
  function StreamStatusDTO () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  StreamStatusDTO.prototype = Object.create(Entity.prototype)
  StreamStatusDTO.prototype.constructor = StreamStatusDTO

  /* === StreamStatusDTO instance methods & fields === */

  Object.assign(StreamStatusDTO.prototype, {

    /**
     * instance fields
     *
     * @memberof models.StreamStatusDTO#
     * @type {Object}
     */
    _fields: {
      enabled: Boolean,
      workStatus: String, /* SETRIX_STREAM_WORK_STATUS_TYPES */
      startTime: String,
      uptimeSeconds: String,
      residentSetSizeBytes: String,
      cpuUsagePercent: Number,
      inputStatuses: ['StreamStatusInputDTO'],
      outputStatuses: ['StreamStatusOutputDTO']
    }
  })

  /**/

  /* === StreamStatusDTO static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(StreamStatusDTO, Entity)
  StreamStatusDTO._name = 'StreamStatusDTO'
  StreamStatusDTO.init()

  return StreamStatusDTO
}
